import type { ReactNode } from 'react';
import { useEffect, useRef } from 'react';

export function Loading({ label = 'Chargement' }: { label?: string }) {
  return (
    <div className="loading" role="status" aria-live="polite">
      <span className="loading__dot" />
      <span className="loading__dot" />
      <span className="loading__dot" />
      <span className="sr-only">{label}</span>
    </div>
  );
}

export function ErrorBox({ error, retry }: { error: unknown; retry?: () => void }) {
  const msg = error instanceof Error ? error.message : 'Erreur inconnue';
  return (
    <div className="state state--error" role="alert">
      <p className="state__title">Ce contenu n’a pas pu être chargé</p>
      <p className="state__text">{msg}</p>
      {retry && (
        <button className="btn" onClick={retry}>
          Réessayer
        </button>
      )}
    </div>
  );
}

export function Empty({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className="state">
      <p className="state__title">{title}</p>
      {children && <div className="state__text">{children}</div>}
    </div>
  );
}

/** Déclenche onMore quand la sentinelle devient visible (listes infinies) */
export function LoadMore({ onMore, active }: { onMore: () => void; active: boolean }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    if (!active || !ref.current) return;
    const io = new IntersectionObserver((e) => e[0].isIntersecting && onMore(), { rootMargin: '600px' });
    io.observe(ref.current);
    return () => io.disconnect();
  }, [active, onMore]);
  return <div ref={ref} className="loadmore">{active && <Loading />}</div>;
}
